import React from 'react';

import { Grid } from '../../../common/components/Grid/Grid';
import {
  GridColumn,
  GridCountFunction,
  GridGetterFunction,
  GridRecord,
} from '../../../common/components/Grid/GridDataTypes';
import momencik from '../../../common/momencik';
import { GetPaymentCollectionDto } from '../../../common/spdCore/autogenerated/spdApiClient';
import mathUtils from '../../../utils/mathUtils';
import numberFormatter from '../../../common/numberFormatter';
import { InvoicePaymentOriginEnumText } from '../../../common/spdCore/validation/enums';

interface PaymentCollectionsSearchProps {
  getData: GridGetterFunction;
  getCount: GridCountFunction;
  onRowClick?: (key: string) => Promise<void> | void | undefined;
  refresh?: boolean;
  withFilterInColumns?: boolean;
  showFilter?: boolean;
}

export const paymentCollectionForGrid = (
  collection: GetPaymentCollectionDto,
): GridRecord => {
  return {
    key: collection.id,
    values: {
      id: collection.id,
      'paymentCollection.systemNumber': collection.systemNumber,
      'paymentCollection.name': collection.name || '',
      'paymentCollection.collectionDate': momencik(
        collection.collectionDate,
        'YYYY-MM-DD',
      ),
      'paymentCollection.totalAmount':
        numberFormatter(
          collection.totalAmount
            ? mathUtils.parse(collection.totalAmount)
            : null,
          true,
        ) || '0,00 zł',
      payment_collection_origin: collection.origin
        ? InvoicePaymentOriginEnumText[collection.origin]
        : '',
    },
    isInactive: !collection.active,
    tdCssClass: {
      'paymentCollection.totalAmount': 'amounts-align-right',
    },
  };
};

export const PaymentCollectionsSearch: React.FC<
  PaymentCollectionsSearchProps
> = props => {
  const columns: GridColumn[] = [
    { header: 'Nr sys.', property: 'paymentCollection.systemNumber' },
    { header: 'Nazwa', property: 'paymentCollection.name' },
    { header: 'Data zbioru', property: 'paymentCollection.collectionDate' },
    {
      header: 'Suma wpłat',
      property: 'paymentCollection.totalAmount',
      noFilter: true,
      noSorting: true,
    },
    { header: 'Pochodzenie', property: 'payment_collection_origin' },
  ];

  return (
    <Grid
      getData={props.getData}
      getDataCount={props.getCount}
      columns={columns}
      showFilter={props.showFilter}
      initialOrderColumn="paymentCollection.systemNumber"
      initialOrderDirection="DESC"
      availablePageSizes={[10, 20, 50]}
      emptyGridMessage={'Brak zbiorów wpłat w systemie'}
      onRowClick={props.onRowClick}
      refresh={props.refresh}
      withHistory={true}
      withFilterInColumns={props.withFilterInColumns}
    />
  );
};
